<main class="panel-right">
    <div class="bar-top bar-top__login">
        <img src="/images/switch2-logo.png" alt="Switch2 logo" class="logo">
    </div>
    <router-outlet #route="outlet" style="display: none;"></router-outlet>
    <bottom-bar></bottom-bar>
</main>


